module.exports = __webpack_public_path__ + "static/media/towels.69d682a8.png";